import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation();

  const faqs = [
    { question: t('faq.q1'), answer: t('faq.a1') },
    { question: t('faq.q2'), answer: t('faq.a2') },
    { question: t('faq.q3'), answer: t('faq.a3') },
    { question: t('faq.q4'), answer: t('faq.a4') },
    { question: t('faq.q5'), answer: t('faq.a5') },
    { question: t('faq.q6'), answer: t('faq.a6') },
    { question: t('faq.q7'), answer: t('faq.a7') },
    { question: t('faq.q8'), answer: t('faq.a8') },
    { question: t('faq.q9'), answer: t('faq.a9') },
    { question: t('faq.q10'), answer: t('faq.a10') },
    { question: t('faq.q11'), answer: t('faq.a11') },
    { question: t('faq.q12'), answer: t('faq.a12') }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-white">
      <section className="py-16 px-4">
         <div className="max-w-7xl mx-auto flex flex-col items-start mb-6">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 text-pink-400" data-aos="fade-down" data-aos-delay="100">{t('faq.title')}</h1>
          <p className="text-xl text-gray-600" data-aos="fade-up" data-aos-delay="200">{t('faq.subtitle')}</p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="glass-card rounded-xl shadow-lg overflow-hidden transition-all duration-200"
                data-aos="fade-up"
                data-aos-delay={index * 50}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-pink-100 transition-colors duration-200"
                >
                  <span className="text-lg font-semibold text-gray-600 pr-4">
                    {faq.question}
                  </span>
                  {openIndex === index ? (
                    <ChevronUp className="w-6 h-6 text-primary-600 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-6 h-6 text-primary-600 flex-shrink-0" />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-700">
                    <p className="pt-4">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-br from-primary-100 to-pink-200 text-gray-600 rounded-2xl shadow-xl p-8 md:p-12 text-center" data-aos="zoom-in-up">
            <h2 className="text-3xl font-bold mb-4 text-pink-400">{t('faq.stillQuestions')}</h2>
            <p className="text-xl text-primary-400 mb-6">{t('faq.stillQuestionsDesc')}</p>
            <a
              href="/contact"
              className="bg-primary-50 hover:bg-pink-100 text-pink-400 px-8 py-4 rounded-full font-semibold transition-all duration-200 shadow-lg hover:shadow-xl border-2 border-pink-300 hover:border-pink-400 hover:scale-105"
            >
              {t('faq.contactMe')}
            </a>
          </div>

        </div>
      </section>
    </div>
  );
};

export default FAQ;
